export default "__VITE_ASSET__Cd$_IcWE__"